<template>
  <div class="home-page-container">
    <nav-component :isMobile="isMobile"></nav-component>
    <div class="homepage-hero">
      <div class="inner-hero-container">
        <div class="hero-copy">
          <h1 id="main-title">Offer rewards that everyone loves.</h1>
          <p>The Global Rewards Solutions platform enables your loyalty, recognition, or channel incentive program members to choose from millions of physical and digital rewards: from merchandise to gift cards to travel experiences. Every order is supported by best-in-class 24/7 customer service.</p>
          <a href="#">SCHEDULE A DEMO</a>
        </div>
        <div class="hero-img">
          <img src="@/assets/img/grs-hero.png" alt />
        </div>
      </div>
      
    </div>
    <div class="homepage-mobile-hero">
      <div class="slide one">
        <h2>
          The World’s Leading Cloud&#x2011;Based
          <br />Reward Management Platform
        </h2>
        <img src="@/assets/img/cloud-icon.png" alt class="cloud-icon" />
        <HomepageIcons class="slider-icons" />
      </div>
    </div>
    <!-- <colours-bar class="home-top-colours"></colours-bar> -->
    
    <div class="one-stop">
      <h2 class="main-site-heading">Global Reward Solutions – Global Procurement &amp; Fulfillment</h2>
      <div class="circle-stats">
        <div class="circle faded-section with-transition-delay">
          <img src="@/assets/img/home-circle-1.png" alt />
        </div>
        <div class="circle middle faded-section">
          <img src="@/assets/img/home-circle-2.png" alt />
        </div>
        <div class="circle faded-section">
          <img src="@/assets/img/home-circle-3.png" alt />
        </div>
      </div>
      <p class="one-stop-copy charcoal">We enable loyalty, recognition, and performance companies everywhere to bring their customers or members the widest reward selection, with best-in-class customer service.</p>
      <div class="personalized-video">
        <transition name="fade" mode="out-in">
          <div class="img-transition" @click="playVideo()" v-if="!isHomepageVideoplayer">
          </div>
          <iframe v-else src="https://player.vimeo.com/video/985100451?color=ffffff&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </transition>
      </div>
      <div class="learn-more">
        <router-link to="/why-grs">
          <button class="learn-more-btn charcoal-btn">LEARN MORE</button>
        </router-link>
      </div>
    </div>
    <div class="trusted">
      <div class="copy-container">
        <p
          class="charcoal"
        >Our platform is trusted to power the rewards programs of leading companies, including:</p>
      </div>
      <div class="logo-container">
        <img class="simple-fade with-transition-delay bell-logo" src="@/assets/img/bell-logo.svg" alt />
        <img class="simple-fade" src="@/assets/img/brother-logo.svg" alt />
        <img class="simple-fade" src="@/assets/img/ford-logo.svg" alt />
        <img class="simple-fade" src="@/assets/img/fujitsu-logo.svg" alt />
        <img class="simple-fade" src="@/assets/img/novartis-logo.svg" alt />
        <img class="simple-fade" src="@/assets/img/delta-logo.svg" alt />
      </div>
    </div>
    <div class="offered">
      <h2>Rewards We Offer</h2>
      <HomepageIcons />
      <div class="learn-more">
        <router-link to="/global-selection">
          <button class="learn-more-btn">LEARN MORE</button>
        </router-link>
      </div>
    </div>
    <div class="our-solutions">
      <h2>Our Solutions</h2>
      <div class="three-col">
        <div class="box blue faded-section">
           <h3>Rewards</h3>
          <p>Easily build a compelling rewards program, powered by our Rewards platform of millions of high-value, premium brand products and digital rewards.</p>
          <router-link to="/solutions/rewards">
            <button class="home-learn-more-btn">LEARN MORE</button>
          </router-link>
        </div>
        <div class="box purp faded-section">
          <img src="@/assets/img/kart-white.svg" class="solutions-kart-logo" alt="">
          <p>Deliver instant membership discounts on thousands of premium brand products, gift cards, travel experiences and&nbsp;more.</p>
          <router-link to="/solutions/kart">
            <button class="home-learn-more-btn">LEARN MORE</button>
          </router-link>
        </div>
        <div class="box blue2 faded-section">
          <img src="@/assets/img/gift-codes-white.svg" class="solutions-giftcodes-logo" alt="">
          <p>A fast, seamless and secure way to reward customers or members with virtual gift codes for instant savings across 185+ countries.</p>
          <router-link to="/solutions/gift-codes">
            <button class="home-learn-more-btn">LEARN MORE</button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="cust-support">
      <h2>Global Customer Support</h2>
      <div class="flex clock-box">
        <img src="@/assets/img/clock-icon.png" alt="">
        <div id="num-text" class="">
          <div>
            <span id="num-zing">98</span>
            <span>%</span>
          </div>
          <p class="simple-fade">
            of all order escalations are resolved within one business day
          </p>
        </div>
      </div>
      <p class="one-stop-copy charcoal">Our customer support team is always ready for action 24/7 through our integrated ticket system.</p>
    </div>
    <div class="supplier">
      <div class="supplier-container">
        <div class="icon">
          <img src="@/assets/img/supplier-icon.png" alt />
        </div>
        <div class="supplier-copy">
          <h2>Become a Rewards Supplier</h2>
          <p>Want to expand your business globally? Become a Reward supplier and you can go global instantly. We can showcase your product to companies, and their customers in over 196 countries.</p>
          <router-link to="/contact">
            <button class="learn-more-btn">CONTACT US</button>
          </router-link>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>
<script>
import carousel from 'vue-owl-carousel';
import HomepageIcons from '@/components/HomepageIcons.vue';
export default {
  name: 'home',
  components: {
    carousel,
    HomepageIcons
  },
  data() {
    return {
      isHomepageVideoplayer: false,
      interval: [],
      isMobile: window.innerWidth < 992
    }
  },
  watch: {
    // $route (to, from) {
    //   this.clockConstructor()
    // }
  },
  methods: {
    fetchTreeCount: function () {
      const baseURI = 'https://api-ms.p2motivate.com/evergrow-trees/trees/funded'
      this.$http.get(baseURI)
      .then((result) => {
        this.interval = result.data
      })
    },
    playVideo() {
      this.isHomepageVideoplayer = !this.isHomepageVideoplayer;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 992;
    }
  },
  created () {
    this.fetchTreeCount()
    this.interval = setInterval(() => this.fetchTreeCount(), 30000)
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
@import url("../css/homepage.css");

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(82, 177, 0, 1);
}
#clock {
  padding-right: 20px;
}
#num-text p {
  margin-top: 0;
}
#num-text div {
  text-align: center;
  color: rgba(82, 177, 0, 1);
  font-weight: 800;
  font-style: normal;
  font-size: 150px;
  width: 250px;
  letter-spacing: -8px;
}

#num-text {
  padding-left: 20px;
}
#num-text span,
#num-text p {
  color: #00A561;
}
#num-text p {
  text-align: left;
  transition: opacity 1s;
  transition-delay: 1.2s;
  font-weight: 500;;
}
#num-text p.out-of-sight {
  opacity: 0;
}

#num-text p.faded {
  opacity: 1;
}
</style>
